import { RootState } from 'src/app/store';
import { AuthState } from './authStore';
import { createSelector } from 'reselect';
import { isUndefined } from 'lodash';

const getState = (state: RootState): AuthState => state.auth;

export const getToken = createSelector(
  getState,
  (state: AuthState): string | undefined => state.storedUser && state.storedUser.token,
);
export const isAuthenticated = (state: RootState): boolean => !isUndefined(getToken(state));

export const getHasPermission = createSelector(
  getState,
  (state: AuthState): boolean | undefined => state.hasPermission,
);
